<template>
  <div style="width: 100%;">
    <el-select v-model="value" placeholder="请选择" style="width: 100%">
      <el-option
        v-for="item in options"
        :key="item.category_id"
        :label="item.name"
        :value="item.category_id"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";

export default {
  components: {},
  props: {
    modelValue: {
      type: String, // 根据你传递的类型，修改这里的类型
      default: "",
    },
  },
  data() {
    return {
      value: this.modelValue,
      options: "",
    };
  },
  created() {
    // 获取文章分类列表
    this.getCategoryList();
    this.change();
  },
  methods: {
    change() {
      // this.$emit("getValue", this.value[this.value.length - 1]);
    },
    getCategoryList() {
      let _this = this;
      _this.axios
        .get(resolveWeiShopApi("/api/weishop/admin/content/article/category/list"))
        .then((res) => {
          if (res.code == 200) {
            _this.options = res.data;
          } else {
            eltips(res.msg, "error");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-input--suffix .el-input__inner {
  height: 34px;
}
</style>
